import { ThemeUICSSObject } from 'theme-ui';
import form from './form';
import { fields } from './fields';

export const validations: ThemeUICSSObject = {
  form,
  fields,
};
